/**
* Component: assetSpecificationReducer.js
* Description: This reducer manages the state related to asset specification.
*/

const initialState = {
  make: '',
  brand: '',
  model: '',
  version:'',
  serialNo: '',
  engineNo: '',
  chassisNo: '',
  manufacturer: '',
  registrationNo: '',
  capacity: '',
  assetStatus: {id: 1, label: 'Functioning ', isvisible: true}, //set default value
  lifeSpan:'',
  depreciationValue:'',
  buildupArea:'',
  footPrint:'',
  landArea:'',
};

const assetSpecificationReducer = (state = initialState, action) => {

  switch (action.type) {
    case 'UPDATE_ASSET_SPECIFICATION':
      return {

        ...state,
        ...action.payload,
      };
    case 'CLEAR_ASSET_SPECIFICATION':
      return {};
    default:
      return state;
  }
};

export default assetSpecificationReducer;
